/** Whether keyboard shortcuts use ⌘ (Apple platforms) rather than Ctrl. */
export const isApplePlatform = (): boolean => /Mac|iPhone|iPad/.test(navigator.userAgent);

/** Label for the platform's shortcut modifier key. */
export const modifierKey = (): string => (isApplePlatform() ? '⌘' : 'Ctrl');

/** Whether there's a mouse or trackpad, and so most likely a keyboard with a Tab key. */
export const hasFinePointer = (): boolean =>
  typeof window.matchMedia !== 'function' || window.matchMedia('(any-pointer: fine)').matches;
